import { v4 as uuid } from 'uuid';

import {
  setUnsubscribeUsersStatusFailed,
  setUnsubscribeUsersStatusPending,
  setUnsubscribeUsersStatusSuccess,
} from './actions';
import { setSocketStatusFailed } from '../../slices/socketStatusSlice';
import { ERequestApiStatus, EWsClientEventType } from '../../types/appState';
import { TThunkAction } from '../../types/redux/thunk';
import { TSessionSucceedState } from '../../types/session';
import { ETelemetryEvents } from '../../types/telemetry';
import { IWSClientUnsubscribeUsersStatusSchema } from '../../types/usersStatus';
import { timeoutPromise } from '../../utils/timeoutPromise';
import { EInternetStatus } from '../internetStatus';

/**
 * Отписка по сокету от получения статуса по массиву id пользователей
 */
export const unsubscribeUsersStatus =
  (requestedUserIds: number[]): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { logger, telemetry, custom: { socket } }) => {
    if (!socket) {
      return;
    }

    const { clientEvents, eventChannel } = socket;

    const {
      session: { status, token },
      socketStatus,
      internetStatus,
    } = getState();

    dispatch(setUnsubscribeUsersStatusPending());

    // в модалке каждый раз когда возвращемся на экран - перезапрашивается сессия
    const isSessionExpired = status !== ERequestApiStatus.Succeed && status !== ERequestApiStatus.Pending;
    const isSocketIsClose = socket?.eventChannel.isChannelClosed() || socketStatus === ERequestApiStatus.Failed;
    const isOffline = internetStatus === EInternetStatus.Offline;

    const uid = uuid();

    if (isSocketIsClose) {
      dispatch(setSocketStatusFailed());
    }

    if (isSessionExpired || isSocketIsClose || isOffline) {
      clientEvents.set(uid, { type: EWsClientEventType.UnsubscribeUsersStatus, status: ERequestApiStatus.Failed });
      dispatch(setUnsubscribeUsersStatusFailed());

      return;
    }

    const wsStatusEvent: IWSClientUnsubscribeUsersStatusSchema = {
      type: 'status',
      uid,
      userId: (token as TSessionSucceedState['token']).userId,
      sessionToken: (token as TSessionSucceedState['token']).sessionToken,
      requestedUserIds,
      action: 'unsubscribe',
    };

    clientEvents.set(uid, {
      status: ERequestApiStatus.Pending,
      type: EWsClientEventType.UnsubscribeUsersStatus,
    });

    try {
      await timeoutPromise(eventChannel.unsubscribeUsersStatus(wsStatusEvent), 10000);
      dispatch(setUnsubscribeUsersStatusSuccess());
    } catch (err) {
      logger.warning(err, {
        domain: 'frontend-chats.unsubscribeUsersStatus.ts',
        message: 'Не удалось отписаться от статуса пользователей по ws',
      });
      telemetry.increment(ETelemetryEvents.ChatWsUserStatusFail);

      clientEvents.set(uid, { type: EWsClientEventType.UnsubscribeUsersStatus, status: ERequestApiStatus.Failed });
      dispatch(setUnsubscribeUsersStatusFailed());
    }
  };
